// ./src/utils/api/catalogFields.ts
//
// Fields NEWER than the gateway that serves them. A gateway that has not been recomposed refuses a WHOLE query over one
// field it does not know, so a read that asks for such a field retries without it — and recognises the refusal here.
// ⚠ EVERY message is read, never `getErrorSummary()`: a gateway refusing two fields sends two unnamed errors, and the
//   summary keeps only the LAST of them (#140 review) — the retry would then drop one field and be refused again.
// ⚠ Pure (a type-only import), so `check-event-setup` runs it on real results.

import type { OpResult } from '@sdflc/api-helpers';

/** Every error message the result carries, named or not. */
const allMessages = (result: OpResult): string[] => (result.errors ?? []).flatMap((item) => item?.errors ?? []);

/** The gateway refused the query over this field on this type. */
const refusedField = (result: OpResult, field: string, type: string): boolean =>
  !result.didSucceed() && allMessages(result).some((message) => new RegExp(`Cannot query field ["']${field}["'] on type ["']${type}["']`).test(message));

/** The gateway refused the setup catalog over `ideas` — it predates #62 P6(h). */
export const refusedIdeas = (result: OpResult): boolean => refusedField(result, 'ideas', 'EventSetupOfferOptions');

/** The gateway refused the setup catalog over a type's `gifts` (#140) — it predates migration 2150's SDL. */
export const refusedGifts = (result: OpResult): boolean => refusedField(result, 'gifts', 'EventSetupType');
